export const create = {
  createSuccessfully: '新しい機械の作成に成功しました！',
}
